import { AnyAction } from 'redux'

import { CONTENT_UPDATE, CONTENT_REVERT, LOCATION_POP, PAGE_UPDATE, PAGE_SIZE_UPDATE } from '~/app/store/constants'
import { REFINEMENT_UPDATE } from '~/app/store/refinement/actions'
import { WARNING_TYPE } from 'shared/constants'
import { TEMPLATE_PURPOSES_UPDATE, SORTING_STRATEGY_UPDATE } from '../debug/actions'
import { createSelector } from 'reselect'
import type { State } from 'shared/types/gallery/state'

const initialState: State.UxState = {
  showSpinner: false,
  warningType: null,
}

export function reducer(state: State.UxState = initialState, action: AnyAction): State.UxState {
  switch (action.type) {
    case PAGE_SIZE_UPDATE:
    case PAGE_UPDATE:
    case REFINEMENT_UPDATE:
    case TEMPLATE_PURPOSES_UPDATE:
    case SORTING_STRATEGY_UPDATE:
      return {
        ...state,
        showSpinner: true,
      }
    case LOCATION_POP:
      return {
        ...state,
        showSpinner: action.payload.showSpinner,
      }
    case CONTENT_REVERT:
      return {
        ...state,
        showSpinner: false,
        warningType: WARNING_TYPE.Content,
      }
    case CONTENT_UPDATE:
      return {
        ...state,
        showSpinner: false,
        warningType: null,
      }
    default:
      return state
  }
}

export const getShowSpinnerSelector = createSelector(
  (state: State.GlobalState) => state.ux,
  (ux) => ({ showSpinner: ux.showSpinner }),
)

export const getShowWarningSelector = createSelector(
  (state: State.GlobalState) => state.ux,
  (ux) => ({ warningType: ux.warningType as WARNING_TYPE }),
)
